export const dropBoolean = [
  { value: 'SIM', label: 'SIM' },
  { value: 'NAO', label: 'NÃO' },
];

export const dropAtivo = [
  { value: 'SIM', label: 'SIM' },
  { value: 'NAO', label: 'NÃO' },
  { value: 'PENDENTE', label: 'PENDENTE' },
];

export const dropTipoPessoa = [
  { value: 'FISICA', label: 'FÍSICA' },
  { value: 'JURIDICA', label: 'JURÍDICA' },
];

export const dropTipoPerfil = [
  { value: 'CLIENTE', label: 'CLIENTE' },
  { value: 'FORNECEDOR', label: 'FORNECEDOR' },
  { value: 'TRANSPORTADOR', label: 'TRANSPORTADOR' },
  { value: 'FILIAL', label: 'FILIAL' },
  { value: 'USUARIO', label: 'USUARIO' },
  { value: 'FUNCIONARIO', label: 'FUNCIONARIO' },
  { value: 'MOTORISTA', label: 'MOTORISTA' },
  { value: 'VENDEDOR', label: 'VENDEDOR' },
  { value: 'REPRESENTANTE', label: 'REPRESENTANTE' },
  { value: 'INSTITUICAO FINANCEIRA', label: 'INSTITUICAO FINANCEIRA' },
  { value: 'OPERADORA DE CARTAO', label: 'OPERADORA DE CARTAO' },
  { value: 'CONTATO', label: 'CONTATO' },
];

export const dropEstadoCivil = [
  { value: 'SOLTEIRO', label: 'SOLTEIRO' },
  { value: 'CASADO', label: 'CASADO' },
  { value: 'DIVORCIADO', label: 'DIVORCIADO' },
  { value: 'DESQUITADO', label: 'DESQUITADO' },
  { value: 'VIÚVO', label: 'VIÚVO' },
];

export const dropSexo = [
  { value: 'MASCULINO', label: 'MASCULINO' },
  { value: 'FEMININO', label: 'FEMININO' },
];

export const dropRegimeTributario = [
  { value: 'LUCRO REAL', label: 'LUCRO REAL' },
  { value: 'LUCRO PRESUMIDO', label: 'LUCRO PRESUMIDO' },
  { value: 'SIMPLES NACIONAL', label: 'SIMPLES NACIONAL' },
];

export const dropRegimeEspecial = [
  { value: 'E-COMMERCE NÃO VINCULADO', label: 'E-COMMERCE NÃO VINCULADO' },
];

export const dropClassificaçãoTributária = [
  {
    value: '00-Industrial - Transformação',
    label: '00-Industrial - Transformação',
  },
  {
    value: '01-Industrial - Beneficiamento',
    label: '01-Industrial - Beneficiamento',
  },
  { value: '03-Industrial - Montagem', label: '03-Industrial - Montagem' },
  {
    value: '04-Industrial - Renovação ou Recondicionamento',
    label: '04-Industrial - Renovação ou Recondicionamento',
  },
  {
    value: '05-Equiparado a industria - Por opção',
    label: '05-Equiparado a industria - Por opção',
  },
  {
    value: '06-Equiparado a industria - Importação direta',
    label: '06-Equiparado a industria - Importação direta',
  },
  {
    value: '07-Equiparado a industria - por lei específica',
    label: '07-Equiparado a industria - por lei específica',
  },
  {
    value: '08-Equiparado a industria - Não enquadrado',
    label: '08-Equiparado a industria - Não enquadrado',
  },
  { value: '09-Outros', label: '09-Outros' },
];

export const dropTipoCartao = [
  { value: 'DEBITO', label: 'DEBITO' },
  { value: 'CREDITO', label: 'CREDITO' },
  { value: 'TICKET', label: 'TICKET' },
];

export const dropTipoMascara = [
  { value: 'FIXO', label: 'FIXO' },
  { value: 'MOVEL', label: 'MOVEL' },
];

export const dropTipoMovimentacao = [
  { value: 'UNIDADE', label: 'UNIDADE' },
  { value: 'ESTRUTURA', label: 'ESTRUTURA' },
];

export const dropTipoDescricao = [
  { value: 'REDUZIDA', label: 'REDUZIDA' },
  { value: 'COMPLETA', label: 'COMPLETA' },
  { value: 'INGLES', label: 'INGLES' },
  { value: 'ESPANHOL', label: 'ESPANHOL' },
  { value: 'CLIENTE', label: 'CLIENTE' },
];

export const dropStatusIntegracao = [
  { value: 'PUBLICADO', label: 'PUBLICADO' },
];

export const dropEstruturaLinhaProduto = [
  { value: 'SIM', label: 'SIM' },
  { value: 'NAO', label: 'NÃO' },
  { value: 'CLIENTE', label: 'CLIENTE' },
];

export const dropIdSped = [
  { value: 'ID', label: 'ID' },
  { value: 'REFERENCIA', label: 'REFERENCIA' },
];

export const dropCusto = [
  { value: 'PADRAO', label: 'PADRAO' },
  { value: 'ESTRUTURA', label: 'ESTRUTURA' },
];

export const dropTipoItem = [
  { value: '00-Mercadoria para revenda', label: '00-Mercadoria para revenda' },
  { value: '01-Matéria prima', label: '01-Matéria prima' },
  { value: '02-Embalagem', label: '02-Embalagem' },
  { value: '03-Produtos em processo', label: '03-Produtos em processo' },
  { value: '04-Produto acabado', label: '04-Produto acabado' },
  { value: '05-Subproduto', label: '05-Subproduto' },
  { value: '06-Produto intermediário', label: '06-Produto intermediário' },
  {
    value: '07-Material de uso e consumo',
    label: '07-Material de uso e consumo',
  },
  { value: '08-Ativo imobilizado', label: '08-Ativo imobilizado' },
  { value: '09-Serviços', label: '09-Serviços' },
  { value: '10-Outros insumos', label: '10-Outros insumos' },
  { value: '99-Outras', label: '99-Outras' },
];

export const dropOrigem = [
  { value: 'FABRICADO', label: 'FABRICADO' },
  { value: 'COMPRADO', label: 'COMPRADO' },
];

export const dropCondicaoMl = [
  { value: 'new', label: 'Novo' },
  { value: 'used', label: 'Usado' },
];

export const dropStatusMl = [
  { value: 'active', label: 'ATIVO' },
  { value: 'paused', label: 'PAUSADO' },
  { value: 'closed', label: 'FECHADO' },
];

export const dropStatusShopee = [
  { value: 'NORMAL', label: 'NORMAL' },
  { value: 'BANNED', label: 'BANIDO' },
  { value: 'SELLER_DELETE', label: 'EXCLUIDO PELO VENDEDOR' },
  { value: 'SHOPEE_DELETE', label: 'EXCLUIDO PELA SHOPEE' },
  { value: 'REVIEWING', label: 'EM REVISÃO' },
];

export const dropLogisticaMl = [
  { value: 'fulfillment', label: 'Full' },
  { value: 'cross_docking', label: 'Coleta' },
  { value: 'drop_off', label: 'Comum' },
  { value: 'self_service', label: 'Flex' },
  { value: 'xd_drop_off', label: 'Places' },
];

export const dropListagemMl = [
  { value: 'Premium', label: 'Premium' },
  { value: 'Diamante', label: 'Diamante' },
  { value: 'Clássico', label: 'Clássico' },
  { value: 'Ouro', label: 'Ouro' },
  { value: 'Prata', label: 'Prata' },
];

export const dropTipoConta = [
  { value: 'APLICAÇÃO', label: 'APLICAÇÃO' },
  { value: 'CAIXA', label: 'CAIXA' },
  { value: 'CORRENTE', label: 'CORRENTE' },
  { value: 'DESCONTO', label: 'DESCONTO' },
  { value: 'MARKETPLACE', label: 'MARKETPLACE' },
];

export const dropDivisao = [
  { value: 'QUANTIDADE', label: 'QUANTIDADE' },
  { value: 'VALOR', label: 'VALOR' },
];

export const dropModulos = [
  { value: 'COMPRAS', label: 'COMPRAS' },
  { value: 'VENDAS', label: 'VENDAS' },
];

export const dropModulo = [
  { value: 'COMPRAS', label: 'COMPRAS' },
  { value: 'VENDAS', label: 'VENDAS' },
  { value: 'GERAL', label: 'GERAL' },
];

export const dropIndPag = [
  { value: '0-A VISTA', label: '0-A VISTA' },
  { value: '1-A PRAZO', label: '1-A PRAZO' },
];

export const dropModalidade = [
  { value: '01-DINHEIRO', label: '01-DINHEIRO' },
  { value: '02-CHEQUE', label: '02-CHEQUE' },
  { value: '03-CARTAO DE CREDITO', label: '03-CARTAO DE CREDITO' },
  { value: '04-CARTAO DE DEBITO', label: '04-CARTAO DE DEBITO' },
  { value: '05-CRÉDITO LOJA', label: '05-CRÉDITO LOJA' },
  { value: '10-VALE ALIMENTAÇÃO', label: '10-VALE ALIMENTAÇÃO' },
  { value: '11-VALE REFEIÇÃO', label: '11-VALE REFEIÇÃO' },
  { value: '12-VALE PRESENTE', label: '12-VALE PRESENTE' },
  { value: '13-VALE COMBUSTIVEL', label: '13-VALE COMBUSTIVEL' },
  { value: '15-BOLETO BANCÁRIO', label: '15-BOLETO BANCÁRIO' },
  { value: '90-SEM PAGAMENTO', label: '90-SEM PAGAMENTO' },
  { value: '98-REFINANCIAMENTO', label: '98-REFINANCIAMENTO' },
  { value: '99-OUTROS', label: '99-OUTROS' },
];

export const dropTipoRodado = [
  { value: '01 - TRUCK', label: '01 - TRUCK' },
  { value: '02 - TOCO', label: '02 - TOCO' },
  { value: '03 - CAVALO MECÂNICO', label: '03 - CAVALO MECÂNICO' },
  { value: '04 - VAN', label: '04 - VAN' },
  { value: '05 - UTILITÁRIO', label: '05 - UTILITÁRIO' },
  { value: '06 - OUTROS', label: '06 - OUTROS' },
];

export const dropTipoCarroceria = [
  { value: '00 - NÃO APLICÁVEL', label: '00 - NÃO APLICÁVEL' },
  { value: '01 - ABERTA', label: '01 - ABERTA' },
  { value: '02 - FECHADA/BAÚ', label: '02 - FECHADA/BAÚ' },
  { value: '03 - GRANELERA', label: '03 - GRANELERA' },
  { value: '04 - PORTA CONTAINER', label: '04 - PORTA CONTAINER' },
  { value: '05 - SIDER', label: '05 - SIDER' },
];

export const dropTipoCarga = [
  { value: 'VIVA', label: 'VIVA' },
  { value: 'PERECIVEL', label: 'PERECIVEL' },
  { value: 'LIQUIDA', label: 'LIQUIDA' },
  { value: 'FRIGORIFICA', label: 'FRIGORIFICA' },
  { value: 'DIVERSOS', label: 'DIVERSOS' },
];

export const dropTipoUnidadeTransporte = [
  { value: '1 - RODOVIÁRIO TRAÇÃO', label: '1 - RODOVIÁRIO TRAÇÃO' },
  { value: '2 - RODOVIÁRIO REBOQUE', label: '2 - RODOVIÁRIO REBOQUE' },
  { value: '3 - NAVIO', label: '3 - NAVIO' },
  { value: '4 - BALSA', label: '4 - BALSA' },
  { value: '5 - AERONAVE', label: '5 - AERONAVE' },
  { value: '6 - VAGÃO', label: '6 - VAGÃO' },
  { value: '7 - OUTROS', label: '7 - OUTROS' },
];

export const dropTipoProprietario = [
  { value: '0 - TAC AGREGADO', label: '0 - TAC AGREGADO' },
  { value: '1 - TAC INDEPENDENTE', label: '1 - TAC INDEPENDENTE' },
  { value: '2 - OUTROS', label: '2 - OUTROS' },
];

export const dropOrgDest = [
  { value: 'MESMO ESTADO', label: 'MESMO ESTADO' },
  { value: 'OUTRO ESTADO', label: 'OUTRO ESTADO' },
  { value: 'OUTRO PAIS', label: 'OUTRO PAIS' },
];

export const dropStatus = [
  { value: 'ATIVO', label: 'ATIVO' },
  { value: 'INATIVO', label: 'INATIVO' },
];

export const dropOperacao = [
  { value: 'DEBITO', label: 'DÉBITO' },
  { value: 'CREDITO', label: 'CRÉDITO' },
];

export const dropTipoPlanoconta = [
  { value: 'ANALITICA', label: 'ANALÍTICA' },
  { value: 'SINTETICA', label: 'SINTÉTICA' },
];

export const dropTipoDespesa = [
  { value: 'FIXA', label: 'FIXA' },
  { value: 'VARIAVEL', label: 'VARIÁVEL' },
];

export const dropTipoCusto = [
  { value: 'DIRETO', label: 'DIRETO' },
  { value: 'INDIRETO', label: 'INDIRETO' },
];

export const dropNTributado = [
  { value: 'ISENTO', label: 'ISENTO' },
  { value: 'OUTROS', label: 'OUTROS' },
  { value: 'NENHUM', label: 'NENHUM' },
];

export const dropOperacaoTd = [
  { value: 'SOMA', label: 'SOMA' },
  { value: 'SUBTRAI', label: 'SUBTRAI' },
  { value: 'NENHUMA', label: 'NENHUMA' },
];

export const dropBaseTeto = [
  { value: 'TRIBUTO', label: 'TRIBUTO' },
  { value: 'TOTAL DOCUMENTO', label: 'TOTAL DOCUMENTO' },
];

export const dropContaContra = [
  { value: 'CAIXA E BANCO', label: 'CAIXA E BANCO' },
  { value: 'CARTÕES', label: 'CARTÕES' },
  { value: 'CHEQUES', label: 'CHEQUES' },
  { value: 'COMPENSAÇÃO', label: 'COMPENSAÇÃO' },
  { value: 'GERAÇÃO DE HAVER', label: 'GERAÇÃO DE HAVER' },
  { value: 'OUTROS', label: 'OUTROS' },
  { value: 'TRANSFERÊNCIAS', label: 'TRANSFERÊNCIAS' },
  { value: 'UTILIZAÇÃO DE HAVER', label: 'UTILIZAÇÃO DE HAVER' },
];

export const dropCtaComplemento = [
  { value: 'ENTIDADE', label: 'ENTIDADE' },
  { value: 'CONTA', label: 'CONTA' },
  { value: 'CTABANCO', label: 'CTABANCO' },
  { value: 'NAO CONTABILIZAR', label: 'NAO CONTABILIZAR' },
];

export const dropParcelas = [
  { value: 'TODAS', label: 'TODAS' },
  { value: 'PRIMEIRA', label: 'PRIMEIRA' },
  { value: 'ULTIMA', label: 'ULTIMA' },
];

export const dropBcIcms = [
  { value: 'SIM', label: 'SIM' },
  { value: 'NAO', label: 'NÃO' },
  { value: 'SUBTRAI', label: 'SUBTRAI' },
];

export const dropGrupoTrib = [
  { value: 'VENDA', label: 'VENDA' },
  { value: 'REMESSA', label: 'REMESSA' },
  { value: 'TRANSFERENCIA', label: 'TRANSFERENCIA' },
];

export const dropTipoAdmissao = [
  { value: '1 - Admissão', label: '1 - Admissão' },
  {
    value: '2 - Transferência de empresa do mesmo grupo econômico',
    label: '2 - Transferência de empresa do mesmo grupo econômico',
  },
  {
    value: '3 - Transferência de empresa consorciada ou de consórcio',
    label: '3 - Transferência de empresa consorciada ou de consórcio',
  },
  {
    value:
      '4 - Transferência por motivo de sucessão, incorporação, cisão ou fusão',
    label:
      '4 - Transferência por motivo de sucessão, incorporação, cisão ou fusão',
  },
  {
    value:
      '5 - Transferência do empregado doméstico para outro representante da mesma unidade familiar',
    label:
      '5 - Transferência do empregado doméstico para outro representante da mesma unidade familiar',
  },
  { value: '6 - Mudança de CPF', label: '6 - Mudança de CPF' },
];

export const dropIndAdmissao = [
  { value: '1 - Normal', label: '1 - Normal' },
  {
    value: '2 - Decorrente de Ação Fiscal',
    label: '2 - Decorrente de Ação Fiscal',
  },
  {
    value: '3 - Decorrente de Decisão Judicial',
    label: '3 - Decorrente de Decisão Judicial',
  },
];

export const dropRegimeTrabalho = [
  { value: '1 - CLT', label: '1 - CLT' },
  { value: '2 - Estatutário', label: '2 - Estatutário' },
];

export const dropRegimePrevidencia = [
  {
    value: '1 - Regime Geral da Previdência Social - RGPS',
    label: '1 - Regime Geral da Previdência Social - RGPS',
  },
  {
    value: '2 - Regime Próprio de Previdência Social - RPPS',
    label: '2 - Regime Próprio de Previdência Social - RPPS',
  },
  {
    value: '3 - Regime de Previdência Social no Exterior',
    label: '3 - Regime de Previdência Social no Exterior',
  },
];

export const dropRegimeJornada = [
  {
    value: '1 - Submetidos a Horário de Trabalho (Cap. II da CLT)',
    label: '1 - Submetidos a Horário de Trabalho (Cap. II da CLT)',
  },
  {
    value: '2 - Atividade Externa especificada no Inciso I do Art. 62 da CLT',
    label: '2 - Atividade Externa especificada no Inciso I do Art. 62 da CLT',
  },
  {
    value: '3 - Funções especificadas no Inciso II do Art. 62 da CLT',
    label: '3 - Funções especificadas no Inciso II do Art. 62 da CLT',
  },
  {
    value: '4 - Teletrabalho, previsto no Inciso III do Art. 62 da CLT',
    label: '4 - Teletrabalho, previsto no Inciso III do Art. 62 da CLT',
  },
];

export const dropFgts = [
  { value: '1 - Optante', label: '1 - Optante' },
  { value: '2 - Não Optante', label: '2 - Não Optante' },
];

export const dropGrauInstrucao = [
  { value: '01 - Analfabeto', label: '01 - Analfabeto' },
  {
    value: '02 - Até o 5º ano incompleto do Ensino Fundamental',
    label: '02 - Até o 5º ano incompleto do Ensino Fundamental',
  },
  {
    value: '03 - 5º ano completo do Ensino Fundamental',
    label: '03 - 5º ano completo do Ensino Fundamental',
  },
  {
    value: '04 - Do 6º ao 9º ano do Ensino Fundamental incompleto',
    label: '04 - Do 6º ao 9º ano do Ensino Fundamental incompleto',
  },
  {
    value: '05 - Ensino Fundamental Completo',
    label: '05 - Ensino Fundamental Completo',
  },
  {
    value: '06 - Ensino Médio incompleto',
    label: '06 - Ensino Médio incompleto',
  },
  { value: '07 - Ensino Médio completo', label: '07 - Ensino Médio completo' },
  {
    value: '08 - Educação Superior incompleta',
    label: '08 - Educação Superior incompleta',
  },
  {
    value: '09 - Educação Superior completa',
    label: '09 - Educação Superior completa',
  },
  {
    value: '10 - Pós-Graduação completa',
    label: '10 - Pós-Graduação completa',
  },
  { value: '11 - Mestrado completo', label: '11 - Mestrado completo' },
  { value: '12 - Doutorado completo', label: '12 - Doutorado completo' },
];

export const dropCategoriaCnh = [
  { value: 'A', label: 'A' },
  { value: 'B', label: 'B' },
  { value: 'C', label: 'C' },
  { value: 'D', label: 'D' },
  { value: 'E', label: 'E' },
  { value: 'AB', label: 'AB' },
  { value: 'AC', label: 'AC' },
  { value: 'AD', label: 'AD' },
  { value: 'AE', label: 'AE' },
];

export const dropRacaCor = [
  { value: '1-BRANCA', label: '1-BRANCA' },
  { value: '2-PRETA', label: '2-PRETA' },
  { value: '3-PARDA', label: '3-PARDA' },
  { value: '4-AMARELA', label: '4-AMARELA' },
  { value: '5-INDIGENA', label: '5-INDIGENA' },
  { value: '6-NAO INFORMADO', label: '6-NAO INFORMADO' },
];

export const dropReligiao = [
  { value: '1-Catolica', label: '1-Catolica' },
  { value: '2-Espirita', label: '2-Espirita' },
  { value: '3-Evangelica', label: '3-Evangelica' },
  { value: '4-Outras', label: '4-Outras' },
];

export const dropHabitacao = [
  { value: '1-Propria', label: '1-Propria' },
  { value: '2-Alugada', label: '2-Alugada' },
  { value: '3-Financiada', label: '3-Financiada' },
  { value: '4-Cedida', label: '4-Cedida' },
];

export const dropTipoAcidente = [
  { value: '1 - Atropelamento', label: '1 - Atropelamento' },
  { value: '2 - Colisão', label: '2 - Colisão' },
  { value: '3 - Outros', label: '3 - Outros' },
];

export const dropOrgaoDeClasse = [
  {
    value: '1 - Conselho Regional de Medicina (CRM)',
    label: '1 - Conselho Regional de Medicina (CRM)',
  },
  {
    value: '2 - Conselho Regional de Odontologia (CRO)',
    label: '2 - Conselho Regional de Odontologia (CRO)',
  },
  {
    value: '3 - Registro do Ministério da Saúde (RMS)',
    label: '3 - Registro do Ministério da Saúde (RMS)',
  },
];

export const dropNaoUso = [
  { value: '1 - Ônus do Cedente', label: '1 - Ônus do Cedente' },
  { value: '2 - Ônus do Cessionário', label: '2 - Ônus do Cessionário' },
  {
    value: '3 - Ônus do Cedente e Cessionário',
    label: '3 - Ônus do Cedente e Cessionário',
  },
];

export const dropNaoRemuneracao = [
  { value: '1 - Apenas do Empregador', label: '1 - Apenas do Empregador' },
  { value: '2 - Apenas do Sindicato', label: '2 - Apenas do Sindicato' },
  {
    value:
      '3 - Parte do Empregador, sendo a diferença e/ou complementação salarial',
    label:
      '3 - Parte do Empregador, sendo a diferença e/ou complementação salarial',
  },
];

export const dropOrgRetificacao = [
  {
    value: '1 - Por iniciativa do empregador',
    label: '1 - Por iniciativa do empregador',
  },
  { value: '2 - Revisão Administrativa', label: '2 - Revisão Administrativa' },
  { value: '3 - Determinação Judicial', label: '3 - Determinação Judicial' },
];

export const dropTipoAvisoPrevio = [
  {
    value: '1-Aviso prévio trabalhado',
    label: '1-Aviso prévio trabalhado',
  },
  {
    value: '2-Aviso prévio indenizado',
    label: '2-Aviso prévio indenizado',
  },
  {
    value:
      '3-Aviso prévio cumprido em casa (dispensa do cumprimento, mas contado o período)',
    label:
      '3-Aviso prévio cumprido em casa (dispensa do cumprimento, mas contado o período)',
  },
];

export const dropMotivoCancelamentoAviso = [
  {
    value: '1 - Reconsideração prevista no artigo 489 da CLT',
    label: '1 - Reconsideração prevista no artigo 489 da CLT',
  },
  { value: '2 - Determinação Judicial', label: '2 - Determinação Judicial' },
  {
    value: '3 - Cumprimento de norma legal',
    label: '3 - Cumprimento de norma legal',
  },
  { value: '9 - Outros', label: '9 - Outros' },
];

export const dropTipoCat = [
  { value: '1 - Inicial', label: '1 - Inicial' },
  { value: '2 - Reabertura', label: '2 - Reabertura' },
  { value: '3 - Comunicaçãoo de Óbito', label: '3 - Comunicação de Óbito' },
];

export const dropIniciativaCat = [
  {
    value: '1 - Iniciativa do empregador',
    label: '1 - Iniciativa do empregador',
  },
  { value: '2 - Ordem judicial', label: '2 - Ordem judicial' },
  {
    value: '3 - Determinação de órgão fiscalizador',
    label: '3 - Determinação de órgão fiscalizador',
  },
];

export const dropLocalCat = [
  {
    value: '1 - Estabelecimento do empregador no Brasil',
    label: '1 - Estabelecimento do empregador no Brasil',
  },
  {
    value: '2 - Estabelecimento do empregador no Exterior',
    label: '2 - Estabelecimento do empregador no Exterior',
  },
  {
    value: '3 - Estabelecimento de terceiros onde o empregador presta serviços',
    label: '3 - Estabelecimento de terceiros onde o empregador presta serviços',
  },
  { value: '4 - Via pública', label: '4 - Via pública' },
  { value: '5 - Área rural', label: '5 - Área rural' },
  { value: '6 - Embarcação', label: '6 - Embarcação' },
  { value: '9 - Outros', label: '9 - Outros' },
];

export const dropLateralidadeCat = [
  { value: '0 - Não aplicável', label: '0 - Não aplicável' },
  { value: '1 - Esquerda', label: '1 - Esquerda' },
  { value: '2 - Direita', label: '2 - Direita' },
  { value: '3 - Ambas', label: '3 - Ambas' },
];

export const dropTipoContrato = [
  { value: '1 - Prazo Indeterminado', label: '1 - Prazo Indeterminado' },
  {
    value: '2 - Prazo determinado, definidi em dias',
    label: '2 - Prazo determinado, definidi em dias',
  },
  {
    value: '3 - Prazo determinado, vinculado a ocorr?ncia de um fato',
    label: '3 - Prazo determinado, vinculado a ocorr?ncia de um fato',
  },
];

export const dropNaturezaAtividade = [
  { value: '1 - Trabalho Urbano', label: '1 - Trabalho Urbano' },
  { value: '2 - Trabalho Rural', label: '2 - Trabalho Rural' },
];

export const dropMotivoAlteracao = [
  { value: '1 - Promoção', label: '1 - Promoção' },
  { value: '2 - Readaptação', label: '2 - Readaptação' },
  { value: '3 - Aproveitamento', label: '3 - Aproveitamento' },
  { value: '8 - Outros', label: '8 - Outros' },
  { value: '9 - Não Alterado', label: '9 - Não Alterado' },
];

export const dropUnidadeSalario = [
  { value: '1 - Por Hora', label: '1 - Por Hora' },
  { value: '2 - Por Dia', label: '2 - Por Dia' },
  { value: '3 - Por Semana', label: '3 - Por Semana' },
  { value: '4 - Por Quinzena', label: '4 - Por Quinzena' },
  { value: '5 - Por Mês', label: '5 - Por Mês' },
  { value: '6 - Por Tarefa', label: '6 - Por Tarefa' },
  {
    value: '7 - Não Aplicável - salario exclusivamente variável',
    label: '7 - Não Aplicável - salario exclusivamente variável',
  },
];

export const dropTipoRegime = [
  {
    value: '1 - Regime Geral da Previdência Social - RGPS',
    label: '1 - Regime Geral da Previdência Social - RGPS',
  },
  {
    value: '2 - Regime Próprio de Previdência Social - RPPS',
    label: '2 - Regime Próprio de Previdência Social - RPPS',
  },
  {
    value: '3 - Regime de Previdência Social no Exterior',
    label: '3 - Regime de Previdência Social no Exterior',
  },
];

export const dropTipoPrevidencia = [
  {
    value: '1 - Plano previdenciario ou único',
    label: '1 - Plano previdenciario ou único',
  },
  { value: '2 - Plano financeiro', label: '2 - Plano financeiro' },
];

export const dropTipoJornada = [
  {
    value: '1 - Jornada com horário diário e folga fixos',
    label: '1 - Jornada com horário diário e folga fixos',
  },
  {
    value:
      '2 - Jornada 12 x 36 (12 horas de trabalho seguidas de 36 horas ininterruptas de descanso)',
    label:
      '2 - Jornada 12 x 36 (12 horas de trabalho seguidas de 36 horas ininterruptas de descanso)',
  },
  {
    value: '3 - Jornada com horário diário fixo e folga variável',
    label: '3 - Jornada com horário diário fixo e folga variável',
  },
  {
    value: '9 - Demais tipos de jornada',
    label: '9 - Demais tipos de jornada',
  },
];

export const dropHorasSemanais = [
  {
    value: '0 - Não é contrato em tempo parcial',
    label: '0 - Não é contrato em tempo parcial',
  },
  {
    value: '1 - Limitado a 25 horas semanais',
    label: '1 - Limitado a 25 horas semanais',
  },
  {
    value: '2 - Limitado a 30 horas semanais',
    label: '2 - Limitado a 30 horas semanais',
  },
  {
    value: '3 - Limitado a 26 horas semanais',
    label: '3 - Limitado a 26 horas semanais',
  },
];

export const dropDiaSemana = [
  { value: '1 - Segunda Feira', label: '1 - Segunda Feira' },
  { value: '2 - Terça Feira', label: '2 - Terça Feira' },
  { value: '3 - Quarta Feira', label: '3 - Quarta Feira' },
  { value: '4 - Quinta Feira', label: '4 - Quinta Feira' },
  { value: '5 - Sexta Feira', label: '5 - Sexta Feira' },
  { value: '6 - Sábado', label: '6 - Sábado' },
  { value: '7 - Domingo', label: '7 - Domingo' },
  { value: '8 - Dia variável', label: '8 - Dia variável' },
];

export const dropPensao = [
  {
    value: '0 - Não existe pensão alimentícia',
    label: '0 - Não existe pensão alimentícia',
  },
  {
    value: '1 - Percentual de pensão alimentícia',
    label: '1 - Percentual de pensão alimentícia',
  },
  {
    value: '2 - Valor de pensão alimentícia',
    label: '2 - Valor de pensão alimentícia',
  },
  {
    value: '3 - Percentual e valor de pensão alimentícia',
    label: '3 - Percentual e valor de pensão alimentícia',
  },
];

export const dropAvisoPrevio = [
  { value: '0 - Cumprimento total', label: '0 - Cumprimento total' },
  {
    value:
      '1 - Cumprimento parcial em razão de obtenção de novo emprego pelo empregado',
    label:
      '1 - Cumprimento parcial em razão de obtenção de novo emprego pelo empregado',
  },
  {
    value: '2 - Cumprimento parcial por iniciativa do empregador',
    label: '2 - Cumprimento parcial por iniciativa do empregador',
  },
  {
    value: '3 - Outras hipóteses de cumprimento parcial do aviso prévio',
    label: '3 - Outras hipóteses de cumprimento parcial do aviso prévio',
  },
  {
    value: '4 - Aviso prévio indenizado ou não exigível',
    label: '4 - Aviso prévio indenizado ou não exigível',
  },
];

export const dropTipoInscricao = [
  { value: '1 - CNPJ', label: '1 - CNPJ' },
  { value: '2 - CPF', label: '2 - CPF' },
];

export const dropClassificacaoEstrangeira = [
  { value: '01 - Visto permanente', label: '01 - Visto permanente' },
  { value: '02 - Visto temporário', label: '02 - Visto temporário' },
  { value: '03 - Asilado', label: '03 - Asilado' },
  { value: '04 - Refugiado', label: '04 - Refugiado' },
  {
    value: '05 - Solicitante de Refúgio',
    label: '05 - Solicitante de Refúgio',
  },
  {
    value: '06 - Residente fora do Brasil',
    label: '06 - Residente fora do Brasil',
  },
  {
    value: '07 - Deficiente físico e com mais de 51 anos',
    label: '07 - Deficiente físico e com mais de 51 anos',
  },
  {
    value: '08 - Com residência provisória e anistiado, em situação irregular',
    label: '08 - Com residência provisória e anistiado, em situação irregular',
  },
  {
    value:
      '09 - Permanência no Brasil em razão de filhos ou cônjuge brasileiros',
    label:
      '09 - Permanência no Brasil em razão de filhos ou cônjuge brasileiros',
  },
  {
    value: '10 - Beneficiado pelo acordo entre países do Mercosul',
    label: '10 - Beneficiado pelo acordo entre países do Mercosul',
  },
  {
    value:
      '11 - Dependente de agente diplomático e/ou consular de países que mantém convênio de reciprocidade para o exercício de atividade remunerada no Brasil',
    label:
      '11 - Dependente de agente diplomático e/ou consular de países que mantém convênio de reciprocidade para o exercício de atividade remunerada no Brasil',
  },
  {
    value:
      '12 - Beneficiado pelo Tratado de Amizade, Cooperação e Consulta entre a República Federativa do Brasil e a República Portuguesa',
    label:
      '12 - Beneficiado pelo Tratado de Amizade, Cooperação e Consulta entre a República Federativa do Brasil e a República Portuguesa',
  },
];

export const dropTipoAvaliacao = [
  { value: '1 - Critério quantitativo', label: '1 - Critério quantitativo' },
  { value: '2 - Critério qualitativo', label: '2 - Critério qualitativo' },
];

export const dropEpi = [
  { value: '0 - Não se aplica', label: '0 - Não se aplica' },
  { value: '1 - Não utilizado', label: '1 - Não utilizado' },
  { value: '2 - Utilizado', label: '2 - Utilizado' },
];

export const dropEpc = [
  { value: '0 - Não se aplica', label: '0 - Não se aplica' },
  { value: '1 - Não implementa', label: '1 - Não implementa' },
  { value: '2 - Implementa', label: '2 - Implementa' },
];

export const dropUnidade = [
  {
    value: '01 - dose diária de ruído (número adimensional) Q=5',
    label: '01 - dose diária de ruído (número adimensional) Q=5',
  },
  {
    value: '02 - decibel linear (dB (linear))',
    label: '02 - decibel linear (dB (linear))',
  },
  { value: '03 - decibel (C) (dB(C))', label: '03 - decibel (C) (dB(C))' },
  { value: '04 - decibel (A) (dB(A))', label: '04 - decibel (A) (dB(A))' },
  {
    value: '05 - quilocaloria por hora (kcal/h);',
    label: '05 - quilocaloria por hora (kcal/h);',
  },
  { value: '06 - gray (Gy)', label: '06 - gray (Gy)' },
  { value: '07 - sievert (Sv)', label: '07 - sievert (Sv)' },
  {
    value: '08 - quilograma-força por centímetro quadrado (kgf/cm2)',
    label: '08 - quilograma-força por centímetro quadrado (kgf/cm2)',
  },
  {
    value: '09 - metro por segundo ao quadrado (m/s2)',
    label: '09 - metro por segundo ao quadrado (m/s2)',
  },
  {
    value: '10 - metro por segundo elevado a 1,75 (m/s1,75)',
    label: '10 - metro por segundo elevado a 1,75 (m/s1,75)',
  },
  {
    value:
      '11 - parte de vapor ou gás por milhão de partes de ar contaminado (ppm)',
    label:
      '11 - parte de vapor ou gás por milhão de partes de ar contaminado (ppm)',
  },
  {
    value: '12 - miligrama por metro cúbico de ar (mg/m3)',
    label: '12 - miligrama por metro cúbico de ar (mg/m3)',
  },
  {
    value: '13 - fibra por centímetro cúbico (f/cm3)',
    label: '13 - fibra por centímetro cúbico (f/cm3)',
  },
  { value: '14 - grau Celsius (ºC)', label: '14 - grau Celsius (ºC)' },
  {
    value: '15 - metro por segundo (m/s)',
    label: '15 - metro por segundo (m/s)',
  },
  { value: '16 - porcentual (%)', label: '16 - porcentual (%)' },
  { value: '17 - lux (lx)', label: '17 - lux (lx)' },
  {
    value: '18 - unidade formadora de colônias por metro cúbico (ufc/m3)',
    label: '18 - unidade formadora de colônias por metro cúbico (ufc/m3)',
  },
  { value: '19 - dose diária', label: '19 - dose diária' },
  { value: '20 - dose mensal', label: '20 - dose mensal' },
  { value: '21 - dose trimestral', label: '21 - dose trimestral' },
  { value: '22 - dose anual', label: '22 - dose anual' },
  { value: '23 - hertz (Hz)', label: '23 - hertz (Hz)' },
  { value: '24 - gigahertz (GHz)', label: '24 - gigahertz (GHz)' },
  { value: '25 - quilohertz (kHz)', label: '25 - quilohertz (kHz)' },
  {
    value: '26 - watt por metro quadrado (W/m2)',
    label: '26 - watt por metro quadrado (W/m2)',
  },
  {
    value: '27 - ampère por metro (A/m)',
    label: '27 - ampère por metro (A/m)',
  },
  { value: '28 - militesla(mT)', label: '28 - militesla(mT)' },
  { value: '29 - microtesla (µT)', label: '29 - microtesla (µT)' },
  { value: '30 - miliampère (mA)', label: '30 - miliampère (mA)' },
  {
    value: '31 - quilovolt por metro (kV/m)',
    label: '31 - quilovolt por metro (kV/m)',
  },
  { value: '32 - volt por metro (V/m)', label: '32 - volt por metro (V/m)' },
  { value: '33 - minuto (min)', label: '33 - minuto (min)' },
  { value: '34 - hora (h)', label: '34 - hora (h)' },
  {
    value: '35 - joule por metro quadrado (J/m2)',
    label: '35 - joule por metro quadrado (J/m2)',
  },
  {
    value: '36 - milijoule por centímetro quadrado (mJ/cm2)',
    label: '36 - milijoule por centímetro quadrado (mJ/cm2)',
  },
  {
    value: '37 - milisievert (mSv) - dose efetiva anual - corpo inteiro',
    label: '37 - milisievert (mSv) - dose efetiva anual - corpo inteiro',
  },
  { value: '38 - atmosfera (atm)', label: '38 - atmosfera (atm)' },
  {
    value: '39 - milhão de partículas por decímetro cúbico (mppdc)',
    label: '39 - milhão de partículas por decímetro cúbico (mppdc)',
  },
  { value: '40 - nanômetro (nm)', label: '40 - nanômetro (nm)' },
  { value: '41 - miliwatt (mW)', label: '41 - miliwatt (mW)' },
  { value: '42 - watt (W)', label: '42 - watt (W)' },
  {
    value: '43 - umidade relativa do ar (UR (%))',
    label: '43 - umidade relativa do ar (UR (%))',
  },
  {
    value: '44 - decibel (A) (dB(A)) NEN Q=3',
    label: '44 - decibel (A) (dB(A)) NEN Q=3',
  },
  {
    value: '45 - milisievert (mSv) - dose equivalente anual - cristalino',
    label: '45 - milisievert (mSv) - dose equivalente anual - cristalino',
  },
  {
    value: '46 - milisievert (mSv) - dose equivalente anual - pele',
    label: '46 - milisievert (mSv) - dose equivalente anual - pele',
  },
  {
    value: '47 - milisievert (mSv) - dose equivalente anual - mãos e pés',
    label: '47 - milisievert (mSv) - dose equivalente anual - mãos e pés',
  },
];

export const dropTipoReintegracao = [
  {
    value: '1 - Reintegração por Decisão Judicial',
    label: '1 - Reintegração por Decisão Judicial',
  },
  {
    value: '2 - Reintegração por Anistia Legal',
    label: '2 - Reintegração por Anistia Legal',
  },
  {
    value: '3 - Reversão de Servidor Público',
    label: '3 - Reversão de Servidor Público',
  },
  {
    value: '4 - Recondução de Servidor Público',
    label: '4 - Recondução de Servidor Público',
  },
  { value: '5 - Reinclusão de Militar', label: '5 - Reinclusão de Militar' },
  { value: '9 - Outros', label: '9 - Outros' },
];

export const dropRemuneracao = [
  { value: '1 - Por Hora', label: '1 - Por Hora' },
  { value: '2 - Por Dia', label: '2 - Por Dia' },
  { value: '3 - Por Semana', label: '3 - Por Semana' },
  { value: '4 - Por Quinzena', label: '4 - Por Quinzena' },
  { value: '5 - Por Mês', label: '5 - Por Mês' },
  { value: '6 - Por Tarefa', label: '6 - Por Tarefa' },
  {
    value: '7 - Não aplicável - salario exclusivamente variável',
    label: '7 - Não aplicável - salario exclusivamente variável',
  },
];

export const dropTipoExame = [
  {
    value: '0 - Exame médico admissional',
    label: '0 - Exame médico admissional',
  },
  {
    value:
      '1 - Exame médico periódico, conforme NR7 do MTb e/ou planejamento do PCMSO',
    label:
      '1 - Exame médico periódico, conforme NR7 do MTb e/ou planejamento do PCMSO',
  },
  {
    value: '2 - Exame médico de retorno ao trabalho',
    label: '2 - Exame médico de retorno ao trabalho',
  },
  {
    value: '3 - Exame médico de mudança de função',
    label: '3 - Exame médico de mudança de função',
  },
  {
    value:
      '4 - Exame médico de monitoração pontual, não enquadrado nos demais casos',
    label:
      '4 - Exame médico de monitoração pontual, não enquadrado nos demais casos',
  },
  {
    value: '9 - Exame médico demissional',
    label: '9 - Exame médico demissional',
  },
];

export const dropResultado = [
  { value: '1 - Apto', label: '1 - Apto' },
  { value: '2 - Inapto', label: '2 - Inapto' },
];

export const dropOrdemExame = [
  { value: '1 - Inicial', label: '1 - Inicial' },
  { value: '2 - Sequencial', label: '2 - Sequencial' },
];

export const dropIndicadorResultado = [
  { value: '1 - Normal', label: '1 - Normal' },
  { value: '2 - Alterado', label: '2 - Alterado' },
  { value: '3 - Estável', label: '3 - Estável' },
  { value: '4 - Agravamento', label: '4 - Agravamento' },
];

export const dropModalidadeTreino = [
  { value: '1 - Presencial', label: '1 - Presencial' },
  {
    value: '2 - Educação a Distância (EaD)',
    label: '2 - Educação a Distância (EaD)',
  },
  { value: '3 - Semipresencial', label: '3 - Semipresencial' },
];

export const dropTipoTreino = [
  { value: '1 - Inicial', label: '1 - Inicial' },
  { value: '2 - Periódico', label: '2 - Periódico' },
  { value: '3 - Reciclagem', label: '3 - Reciclagem' },
  { value: '4 - Eventual', label: '4 - Eventual' },
  { value: '5 - Outros', label: '5 - Outros' },
];

export const dropTipoProfissional = [
  {
    value: '1 - Profissional empregado do declarante',
    label: '1 - Profissional empregado do declarante',
  },
  {
    value:
      '2 - Profissional sem vínculo de emprego/estatutário com o declarante',
    label:
      '2 - Profissional sem vínculo de emprego/estatutário com o declarante',
  },
];

export const dropNacionalidadeProfissional = [
  { value: '1 - Brasileiro', label: '1 - Brasileiro' },
  { value: '2 - Estrangeiro', label: '2 - Estrangeiro' },
];

export const dropStatusAnuncio = [
  { value: 'SIM', label: 'ATIVO' },
  { value: 'NAO', label: 'INATIVO' },
];

export const dropTipoParada = [
  { value: 'Mecanica', label: 'Mecanica' },
  { value: 'Eletrica', label: 'Eletrica' },
  { value: 'Setup', label: 'Setup' },
  { value: 'Qualidade', label: 'Qualidade' },
  { value: 'Falta material', label: 'Falta material' },
  { value: 'Falta de pessoal', label: 'Falta de pessoal' },
  { value: 'Sem Producao', label: 'Sem Producao' },
  { value: 'Manutencao', label: 'Manutencao' },
  { value: 'Limpeza', label: 'Limpeza' },
  { value: 'Outros', label: 'Outros' },
];

export const dropGrupoQualidade = [
  { value: 'EFICIÊNCIA', label: 'EFICIÊNCIA' },
  { value: 'EFICÁCIA', label: 'EFICÁCIA' },
  { value: 'EFETIVIDADE', label: 'EFETIVIDADE' },
  { value: 'ATENDIMENTO', label: 'ATENDIMENTO' },
  { value: 'SEGURANÇA', label: 'SEGURANÇA' },
];

export const dropFretePorConta = [
  {
    value: '0 - CONTRATACAO DO FRETE POR CONTA DO REMETENTE (CIF)',
    label: '0 - CONTRATACAO DO FRETE POR CONTA DO REMETENTE (CIF)',
  },
  {
    value: '1 - CONTRATACAO DO FRETE POR CONTA DO DESTINATARIO (FOB)',
    label: '1 - CONTRATACAO DO FRETE POR CONTA DO DESTINATARIO (FOB)',
  },
  {
    value: '2 - CONTRATACAO DO FRETE POR CONTA DE TERCEIROS',
    label: '2 - CONTRATACAO DO FRETE POR CONTA DE TERCEIROS',
  },
  {
    value: '3 - TRANSPORTE PROPRIO POR CONTA DO REMETENTE',
    label: '3 - TRANSPORTE PROPRIO POR CONTA DO REMETENTE',
  },
  {
    value: '4 - TRANSPORTE PROPRIO POR CONTA DO DESTINATARIO',
    label: '4 - TRANSPORTE PROPRIO POR CONTA DO DESTINATARIO',
  },
  {
    value: '9 - SEM OCORRENCIA DE TRANSPORTE',
    label: '9 - SEM OCORRENCIA DE TRANSPORTE',
  },
];

export const dropModeloSerie = [
  { value: 'NFe', label: 'NFe' },
  { value: 'NFSe', label: 'NFSe' },
  { value: 'CTe', label: 'CTe' },
  { value: 'NFCe', label: 'NFCe' },
  { value: 'CFe', label: 'CFe' },
  { value: 'NF', label: 'NF' },
  { value: 'MDFe', label: 'MDFe' },
  { value: 'CUPOM', label: 'CUPOM' },
  { value: 'FATURA', label: 'FATURA' },
];
